

































import {Component, Vue} from 'vue-property-decorator';
import deck from '@/store/modules/deck';

@Component
export default class SlideNav extends Vue {

    private timeoutId: any = null;
    previewSlide(index: number, preview: boolean) {
        // if (preview) {
        //     clearTimeout(this.timeoutId);
        //     console.log('preview ' + index);
        //     // this.chooseSlide(index);
        // }
        // if (!preview) {
        //     this.timeoutId = setTimeout(() => {
        //         console.log('unpreview ' + this.currentSlide);
        //     }, 200);
        // }
    }

    isActive(index: number) {
        return index + 1 === this.currentSlide;
    }

    tabStyle(index: number) {
        if (this.leftMore(index)) {
            return 'leftMore';
        }
        if (this.rightMore(index)) {
            return 'rightMore';
        }
        return '';
    }

    leftMore(index: number) {
        return this.slides.length > 2 &&
            index === 0 &&
            !this.isVisible(1);
    }

    rightMore(index: number) {
        return this.slides.length > 2 &&
            index === this.slides.length - 1 &&
            !this.isVisible(this.slides.length - 2);
    }

    isVisible(index: number) {
        if (this.slides.length < 9) {
            return true;
        }
        if (index === 0) {
            return true;
        }
        if (index === this.slides.length - 1) {
            return true;
        }
        const {min, max} = this.getNearestIndexes(this.slides.length, this.currentSlide);
        if (index >= min && index <= max) {
            return true;
        }

        return false;
    }

    getNearestIndexes(len: number, pos: number) {
        let min = pos - 3;
        let max = pos + 3;

        let diff = 0;
        if (min < 0) {
            diff = min;
        }
        if (max >= len) {
            diff = max - (len - 1);
        }
        max -= diff;
        min -= diff;

        if (min === 0 && max !== len - 1) {
            max += 1;
        }
        if (max === len - 1 && min !== 0) {
            min -= 1;
        }

        return {min, max};
    }

    get slides() {
        return deck.Slides;
    }

    get currentSlide() {
        return deck.nav.currentSlide;
    }

    chooseSlide(index: number) {
        deck.setCurrentSlide(index);
    }

}

